import React from 'react'
import { Form, Input } from 'antd'
import styles from './styles.module.scss'
const InputField = ({
  label,
  name,
  placeholder,
  rules = [],
  required = false,
  onChange,
  value = '',
  style,
  type = 'text',
  form,
  maxLength = 255,
  ...props
}) => {
  if (type === 'text') {
    return (
      <Form.Item
        label={label}
        name={name}
        {...props}
        className={styles.formItem}
        rules={[
          ...(required
            ? [
                {
                  required: true,
                  message: `Vui lòng chọn ${label.toLowerCase()}`
                }
              ]
            : []),
          ...rules
        ]}
      >
        <Input
          style={style}
          // placeholder={placeholder || `Vui lòng nhập ${label.toLowerCase()}`}
          placeholder={`Vui lòng nhập thông tin`}
          onChange={onChange}
          value={value}
          onBlur={(e) => {
            form.setFields([
              {
                name: name,
                value: e.target.value?.trim()
              }
            ])
          }}
          maxLength={maxLength}
        />
      </Form.Item>
    )
  }
  if (type === 'number') {
    return (
      <Form.Item
        label={label}
        name={name}
        {...props}
        className={styles.formItem}
        // rules={[{ required: true, message: `Vui lòng nhập ${label.toLowerCase()}!` }, ...rules]}
      >
        <Input
          style={style}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
      </Form.Item>
    )
  }
}

export default InputField
